import { AddLocation, WLocation } from "@/types/inventoryV2";

export const getLocationIdx = (location: WLocation | AddLocation | null | undefined) => {
  if (!location) return '';
  const parts = [location.l1, location.l2, location.l3, location.l4, location.l5];
  // 找到最后一个有值的索引
  let lastIndex = 0;
  for (let i = 0; i < parts.length; i++) {
    if (parts[i] !== undefined && parts[i] !== null) {
      lastIndex = i;
    } else {
      break;
    }
  }
  return parts.slice(0, lastIndex + 1).join('-');
}